import React, {
    ComponentProps,
    PropsWithChildren,
} from 'react';
import {
    MappedComponentProperties,
} from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './ApplicationHeading.css';
import { Title } from '../../importCL';

export interface IApplicationHeadingProps extends MappedComponentProperties {
    headlineStatement?: string;
}

type THeadingTags = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export const ApplicationHeadingEditConfig = {
    emptyLabel: 'Application Heading',
    isEmpty: (props: PropsWithChildren<IApplicationHeadingProps>) => {
        return !props;
    },
};

const ApplicationHeading = (
    props: PropsWithChildren<IApplicationHeadingProps>,
): JSX.Element => {
    const headlineHasHeadingTag = props.headlineStatement?.match(/h[1-6]/g);

    return (
        <div
            id='application-heading'
            className={`ApplicationHeading`}
        >
            <Title className='ApplicationHeading__headline' tag={headlineHasHeadingTag ? headlineHasHeadingTag[0] as THeadingTags : 'h2'}>
                {transformHTMLParserLinks(props.headlineStatement?.replace(/<h[1-6]>|<\/h[1-6]>|<p>|<\/p>/g, ''))}
            </Title>
        </div>
    );
};

export default ApplicationHeading;
